import mermaid from 'mermaid';

mermaid.initialize({ startOnLoad: false, fontFamily: 'Inter, Helevetica, Arial, sans-serif', theme: 'base' });

export const MermaidConfig = {
  get: () => {
    return mermaid;
  },
};
